// allDataService.js
// Service for loading all essential application data before the UI is shown.
// The service coordinates calls across the individual Pinia stores and exposes
// a global reactive flag for "all metadata loaded".

import { ref } from 'vue'
import { useCommunitiesStore } from '@/stores/communitiesStore'
import { useCommunityCompaniesStore } from '@/stores/communityCompaniesStore'
import { useMeteringPointMembershipsStore } from '@/stores/meteringPointMembershipsStore'
import { useSnackbarStore } from '@es-bill/es-bill-common-components'
import i18n from '@/plugins/i18n'

// This function should be awaited before the UI is shown (e.g. during the
// splash-screen phase) and can also be reused later whenever a full reload of
// metadata is required.
export const allMetaDataLoaded = ref(false)
export const membershipMetadataLoaded = ref(false)

export async function fetchMembershipData() {
  if (membershipMetadataLoaded.value) return
  const meteringPointMembershipsStore = useMeteringPointMembershipsStore()
  await Promise.all([
    meteringPointMembershipsStore.fetchMeteringPointMemberships(),
    meteringPointMembershipsStore.fetchMeteringPointMembershipsCm(),
  ])
  membershipMetadataLoaded.value = true
}

export async function fetchAllData({ includeMemberships = true } = {}) {
  const communitiesStore = useCommunitiesStore()
  const companiesStore = useCommunityCompaniesStore()
  const snackbarStore = useSnackbarStore()

  // Reset loaded flag so dependants know we are reloading.
  allMetaDataLoaded.value = false

  try {
    // Fetch everything in parallel.
    const requests = [
      communitiesStore.fetchCommunities(),
      companiesStore.fetchCommunityCompanies(),
      // applicantStore.fetchApplications(),
    ]
    if (includeMemberships) requests.push(fetchMembershipData())
    await Promise.all(requests)

    allMetaDataLoaded.value = true
  } catch (error) {
    snackbarStore.showSnackbar(
      i18n.global.t('connectionProblem'),
      '',
      'Warning',
      10000,
      []
    )

    // Retry after a delay...
    setTimeout(() => {
      location.reload()
    }, 10 * 1000)
  }
}
